// extracted by mini-css-extract-plugin
module.exports = {"ParagraphSmallText__root":"_1Krx"};